import { render } from "./Petty_Cash.vue?vue&type=template&id=78a8e0ce"
import script from "./Petty_Cash.vue?vue&type=script&lang=js"
export * from "./Petty_Cash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__